const defaultOptions: RequestInit = {
	headers: {
		'Content-type': 'application/json'
	}
};

const XSRF_TOKEN_INPUT_NAME = '__RequestVerificationToken';
const XSRF_TOKEN_HEADER_NAME = 'X-XSRF-Token';

export const api = {
	call: async (url: string, options: RequestInit = {}) => {
		const response = await fetch(url, {
			...defaultOptions,
			...options,
			headers: {
				...defaultOptions.headers,
				...options.headers
			}
		});

		if (!response.ok) {
			throw new Error('Error from response ');
		}

		return response.json();
	},
	get: (url: string) => api.call(url, { method: 'get' }),
	put: (url: string, body: Record<string, any>) => api.call(url, { method: 'put', body: JSON.stringify(body) }),
	post: (url: string, body: Record<string, any>) => {

		/** Tjek for hidden input felter for at
		 * se om der er sat en xsrf token.
		 */
		const hiddenInputFields: HTMLInputElement[] = Array.from(document.querySelectorAll('input[type="hidden"]'));
		const headers = {};

		if (hiddenInputFields.length > 0) {
			const xsrf = hiddenInputFields.find((input) => input.name === XSRF_TOKEN_INPUT_NAME);

			/** Hvis den findes så tilføj den til headers */
			if (xsrf) {
				headers[XSRF_TOKEN_HEADER_NAME] = xsrf.value;
			}
		}

		return api.call(url, { method: 'post', body: JSON.stringify(body), headers });
	},
	delete: (url:string) => api.call(url, { method: 'delete' })
};


/**
 * Eskporter funktioner
 *
 */

export const opretLivsHistorie = (endpoint, payload) => api.post(endpoint, payload);

const delay = (time?:number, reject?:boolean) => async payload => {
	return new Promise(( res, rej ) => {
		setTimeout(async () => {
			reject ? rej(new Error('rejected')) : res(payload);
		}, time || 1000);
	});
};

export const resolve = delay(1000);
export const reject = delay(1000, true);